import React, { FC } from 'react'

import { getAddressCaught } from '@ambire-common/utils/getAddressCaught'
import { isExtension } from '@web/constants/browserapi'

import ExtensionContractName from './ExtensionContractName'
import LocalContractName from './LocalContractName'
import { ContractNameChildren } from './types'

interface Props {
  address: string
  chainId: bigint
  children: ContractNameChildren
}

/**
 * Resolves a contract address to a human name and hands it to `children`.
 *
 * For places that print a RAW address (the expanded "Interacting with (to)"
 * details, the activity list) and therefore cannot use <HumanizerAddress />,
 * which shortens it. The name source is the same ContractNamesController, so a
 * DEX router shows as e.g. "PulseX V2" here too.
 *
 * The extension/non-extension split mirrors `HumanizerAddressInner`: only the
 * extension has the controller in a background service worker.
 */
const ContractName: FC<Props> = ({ address, chainId, children }) => {
  const checksummedAddress = getAddressCaught(address)

  if (!checksummedAddress) return <>{children(undefined)}</>

  return isExtension ? (
    <ExtensionContractName address={checksummedAddress} chainId={chainId}>
      {children}
    </ExtensionContractName>
  ) : (
    <LocalContractName address={checksummedAddress} chainId={chainId}>
      {children}
    </LocalContractName>
  )
}

export default ContractName
